export const TIMEFRAMES = ['Morning', 'Evening', 'Overnight'] as const;

export const DAYS_OF_WEEK = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'] as const;

export const STACKED_BAR_CATEGORIES = [
  { key: 'unfulfilledHours', label: 'Unfulfilled Hours', color: '#2D2B55' },
  { key: 'agencyHours', label: 'Agency Hours', color: '#4A4580' },
  { key: 'calloutHours', label: 'Call Out Hours', color: '#E8993E' },
  { key: 'assignedHours', label: 'Assigned Hours', color: '#EAEAF2' },
] as const;

export const KPI_CARD_LABELS = [
  'Call Out Hours',
  'Daily Overtime Hours',
  'Unfulfilled Hours',
  'Weekly Overtime Hours',
  'Scheduled Hours',
] as const;

export const LABOR_COST_DASHBOARD_PATH = '/reports/labor-cost';

export const DATA_TABLE_PAGE_SIZE = 10;

export const CALLOUT_TIMEFRAME_HEATMAP_COLOR = '#4E4785';
